import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase.utils.js';
import {
  convertState,
  createLocalStorageAdapter,
  isEmptyState,
  logMigration,
  needsMigration,
  serializeState,
} from '../mlb-the-show/storage.js';

const trackerRef = (uid) => doc(db, 'users', uid, 'mlbTheShow', 'tracker');
const backupRef = (uid) => doc(db, 'users', uid, 'mlbTheShow', 'tracker-backup-v1');

async function persist(uid, state) {
  await setDoc(trackerRef(uid), { ...serializeState(state), updatedAt: serverTimestamp() });
}

async function migrate(uid, raw) {
  const { state, report } = convertState(raw);
  const backup = await getDoc(backupRef(uid));
  if (!backup.exists()) await setDoc(backupRef(uid), { ...raw, backedUpAt: serverTimestamp() });
  await persist(uid, state);
  logMigration('account', report);
  return state;
}

export function createFirestoreAdapter(uid, guest = createLocalStorageAdapter()) {
  return {
    async load() {
      const snap = await getDoc(trackerRef(uid));
      const raw = snap.exists() ? snap.data() : null;
      const cloud = needsMigration(raw) ? await migrate(uid, raw) : convertState(raw).state;
      if (!isEmptyState(cloud)) return cloud;
      const local = await guest.load();
      if (!isEmptyState(local)) await persist(uid, local);
      return local;
    },
    async save(state) {
      await persist(uid, state);
    },
  };
}
